const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: []

};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'CONTA_BANCARIA_MODO_TELA':
			return {
				...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'CONTA_BANCARIA_LISTADO':
			return { ...state, lista: action.payload.data };

		case 'CONTA_BANCARIA_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		default:
			return state;
	}
}
